var map = {
	"./1.JPG": 4448,
	"./10.JPG": 74,
	"./11.JPG": 6855,
	"./12.JPG": 9080,
	"./13.JPG": 4469,
	"./14.JPG": 2974,
	"./15.JPG": 6395,
	"./16.JPG": 284,
	"./17.JPG": 697,
	"./18.JPG": 7538,
	"./2.JPG": 383,
	"./3.JPG": 2130,
	"./4.JPG": 913,
	"./5.JPG": 948,
	"./6.JPG": 6291,
	"./7.JPG": 8278,
	"./8.JPG": 5413,
	"./9.JPG": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7504;